<template>
<div class="colapsables" id="v-step-2">
    <div class="edicion_block " >
        
        <h4 v-if="$util.isLoyaltyCustomizer()" class="mb10">{{$t('sobre.loyalty')}}</h4>
        <h4 v-else-if="!cardVal.isLanding" class="mb10">{{$t('sobre.loyalty')}}</h4>
        <h4 v-else-if="cardVal.isLanding" class="mb10"></h4>
        
        <span v-if="$util.isLoyaltyCustomizer()">{{$t('sobre.dedi')}}</span>
        <span v-else-if="!cardVal.isLanding" class="mb10">{{$t('sobre.landingsub')}}</span>
        <span v-else-if="cardVal.isLanding" class="mb10">{{$t('sobre.landingsub')}}</span>

        <draggable class="row text-center module_row" 
        v-model="list" 
        handle=".handle"
        :options="dragOptions" 
        :move="onMove" 
        @start="isDragging=true" 
        @end="isDragging=false">
       
          <div  class="module_col"  v-for="element in $util.sobreElements()" :key="element.foto"  v-if="element.tipo !== 'beta' &&
             !(cardVal.loyalty_id && element.nombre === 'Leads')">
                <div :class="$util.isProElementosSobre(getUser,element)?'module_block handle  manito mt15 mb15':'module_block handle manito mt15 mb15'">
                    <div class="module_img" >
                        <img :src="blockIconSrc(element)">
                        <h6 v-if="element.dragLabel">{{ element.dragLabel }}</h6>
                        <h6 v-else>{{ $t("drags." + element.compo)  }}</h6>
                    </div>
                    <span v-if="!($util.isLoyaltyCustomizer()) && element.tipo!='freemium' && element.tipo!='pro'" :class="'label '+element.tipo+' mt5 mb5'" style="text-transform:capitalize">{{element.tipo}}</span>
                </div>
            </div>
      </draggable>
    </div>
</div>
</template>

<script>

import draggable from "vuedraggable";
import { Icon } from "@iconify/vue2"
import { blockIconSrc } from '@/features/editor/bloques/blockIcons'

export default {
  props:['profile'],
  data(){
      return{
          getUser:this.profile,
          list:[],
          editable: true,
          cardVal:this.$store.getters.editingLinckard,
          isDragging: false,
          delayedDragging: false
    };
  },
  created:function(){
     this.list= this.$util.sobreElements().map((elemento, index) => {
        return { 
          ...elemento,
          order: index + 1, 
          fixed: false ,
        };
      });
  },
  methods: {
      blockIconSrc,
      switchSobreBackground(){
          this.$util.closeAllDivs();
          this.switchCompSobre('leftColSobreA');
      },
      switchCompSobre(comp) {
          this.$bus.$emit("switchCompSobre", comp);
      },
      onMove({ relatedContext, draggedContext }) {
        const type = this.getUser?.sectors?.filter(sector=> sector.id == this.cardVal.sector_id)[0]?.type
        if(!this.$util.isProElementosSobreModal(this.$modal,this.getUser,draggedContext.element, type))return false
        
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
        
      },
    },
 
  computed: {
      dragOptions() {
        return {

          group:{ name:'people',  pull:'clone' , put:false},
          animation: 0,
          disabled: !this.editable,
          ghostClass: "ghost",
        };
      },
      
  },
  watch: {
    isDragging(newValue) {

      this.switchSobreBackground();
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
          this.delayedDragging = false;
        });
      this.list= this.$util.sobreElements().map((elemento, index) => {
        return { 
          foto:elemento.foto,
          nombre:elemento.nombre,
          family:elemento.family,
          color:elemento.color,
          size:elemento.size,
          background:elemento.background,
          lineh:elemento.lineh,
          weight:elemento.weight,
          compo:elemento.compo,
          design:elemento.design, 
          tipo:elemento.tipo,
          order: index + 1, 
          fixed: false ,

          desc_family:elemento.desc_family,
          desc_color:elemento.desc_color,
          desc_size:elemento.desc_size,
          desc_lineh:elemento.desc_lineh,
          desc_weight:elemento.desc_weight,

          icon_size:elemento.icon_size,
          icon_color:elemento.icon_color,
          value:elemento.value,
          desc:elemento.desc,
        };
      }
      );
    },
    
  },
  components: {
    draggable,
    Icon
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.module_img img{
margin-bottom:5px !important;
}
/* Cada tipo de bloque en una tarjeta blanca redondeada (icono + nombre centrados),
   como estaba antes. Los iconos nuevos (Bloque_*.svg) traen viewBox sin width/height,
   por eso ademas se limita su tamano. */
.colapsables .edicion_block .module_block{
    background:#ffffff;
    border-radius:14px;
    padding:14px 8px;
    cursor:pointer;
    transition:box-shadow .15s ease;
    height:116px;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
}
.colapsables .edicion_block .module_block:hover{
    box-shadow:0 2px 10px rgba(0,0,0,.08);
}
.colapsables .edicion_block .module_block .module_img{
    display:flex;
    flex-direction:column;
    align-items:center;
    gap:12px;
}
.colapsables .edicion_block .module_block .module_img img{
    max-width:38px !important;
    margin:0 !important;
}
.colapsables .edicion_block .module_block .module_img h6{
    position:static !important;
    bottom:auto;
    margin:0;
}
.edicion_block .module_col{
    -ms-flex: 0 0 33.333333%;
    -webkit-box-flex: 0;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}
</style>
